import { render } from "./KYCPages.vue?vue&type=template&id=688976f7&scoped=true"
import script from "./KYCPages.vue?vue&type=script&lang=js"
export * from "./KYCPages.vue?vue&type=script&lang=js"

import "./KYCPages.vue?vue&type=style&index=0&id=688976f7&lang=css"
import "./KYCPages.vue?vue&type=style&index=1&id=688976f7&scoped=true&lang=css"

import exportComponent from "/Users/bilalahmed/Desktop/DS-TWO/KYC-Analysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688976f7"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
